import React, { Component } from 'react'
import "../styles/StyledInput.css"

export default class StyledInput extends Component {
    render() {
        return (
            <input id={this.props.id} name={this.props.name} className="StyledInput" onChange={this.props.onChange} type={this.props.type} defaultValue={this.props.defaultValue} />
        )
    }
}
